import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 2 }
const _hoisted_4 = { key: 3 }
const _hoisted_5 = {
  key: 4,
  class: "motor-error__actions"
}

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { storeToRefs } from 'pinia'
import { useDeviceStore } from '@/store/deviceStore'
import { usePositionStore } from '@/store/positionStore'
import { useMqttStore } from '@/store/mqttStore'
import { BfButton, ButtonType } from '@finetic/bikefitting-ui'
import { NAlert, useMessage } from 'naive-ui'
import { Icon } from '@iconify/vue'
import { deviceType } from '@/types/device'


export default /*@__PURE__*/_defineComponent({
  __name: 'MotorError',
  props: {
    device: { default: deviceType.handlebar }
  },
  setup(__props: any) {

const { t } = useI18n()
const deviceStore = useDeviceStore()
const positionStore = usePositionStore()
const mqttStore = useMqttStore()
const message = useMessage()

const { motorStatus } = storeToRefs(deviceStore)
const { connected } = storeToRefs(mqttStore)
const { doResetMotors } = positionStore

const props = __props

const overcurrent = computed(() => {
  switch (props.device) {
    case deviceType.handlebar:
      return (
        motorStatus.value.handleBar.x.overcurrent ||
        motorStatus.value.handleBar.y.overcurrent
      )

    case deviceType.saddle:
      return (
        motorStatus.value.saddle.x.overcurrent ||
        motorStatus.value.saddle.y.overcurrent
      )

    default:
      return false
  }
})

const stalled = computed(() => {
  switch (props.device) {
    case deviceType.handlebar:
      return (
        motorStatus.value.handleBar.x.stalled ||
        motorStatus.value.handleBar.y.stalled
      )

    case deviceType.saddle:
      return (
        motorStatus.value.saddle.x.stalled || motorStatus.value.saddle.y.stalled
      )

    default:
      return false
  }
})

const limitSwitch = computed(() => {
  switch (props.device) {
    case deviceType.handlebar:
      return (
        motorStatus.value.handleBar.x.limitSwitch ||
        motorStatus.value.handleBar.y.limitSwitch
      )

    case deviceType.saddle:
      return (
        motorStatus.value.saddle.x.limitSwitch ||
        motorStatus.value.saddle.y.limitSwitch
      )

    default:
      return false
  }
})

const resetMotors = async () => {
  message.loading(t('common.fitbike.resetMotors'))

  doResetMotors()

  if (motorStatus.value.hasHadHighTemperature) {
    motorStatus.value.hasHadHighTemperature = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (overcurrent.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_unref(NAlert), {
            title: _unref(t)('common.fitbike.error.motor.overcurrent.index'),
            bordered: false
          }, {
            icon: _withCtx(() => [
              _createVNode(_unref(Icon), {
                icon: "mdi:information-outline",
                style: { fontSize: '24px' }
              })
            ]),
            default: _withCtx(() => [
              _createElementVNode("p", null, _toDisplayString(_unref(t)('common.fitbike.error.motor.overcurrent.content')), 1)
            ]),
            _: 1
          }, 8, ["title"])
        ]))
      : _createCommentVNode("", true),
    (stalled.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_unref(NAlert), {
            title: _unref(t)('common.fitbike.error.motor.stalled.index'),
            bordered: false
          }, {
            icon: _withCtx(() => [
              _createVNode(_unref(Icon), {
                icon: "mdi:information-outline",
                style: { fontSize: '24px' }
              })
            ]),
            default: _withCtx(() => [
              _createElementVNode("p", null, _toDisplayString(_unref(t)('common.fitbike.error.motor.stalled.content')), 1)
            ]),
            _: 1
          }, 8, ["title"])
        ]))
      : _createCommentVNode("", true),
    (limitSwitch.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_unref(NAlert), {
            title: _unref(t)('common.fitbike.error.motor.limitSwitch.index'),
            bordered: false
          }, {
            icon: _withCtx(() => [
              _createVNode(_unref(Icon), {
                icon: "mdi:information-outline",
                style: { fontSize: '24px' }
              })
            ]),
            default: _withCtx(() => [
              _createElementVNode("p", null, _toDisplayString(_unref(t)('common.fitbike.error.motor.limitSwitch.content')), 1)
            ]),
            _: 1
          }, 8, ["title"])
        ]))
      : _createCommentVNode("", true),
    (_unref(motorStatus).highTemperature || _unref(motorStatus).hasHadHighTemperature)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_unref(NAlert), {
            title: _unref(t)('common.fitbike.error.motor.highTemperature.index'),
            bordered: false
          }, {
            icon: _withCtx(() => [
              _createVNode(_unref(Icon), {
                icon: "mdi:information-outline",
                style: { fontSize: '24px' }
              })
            ]),
            default: _withCtx(() => [
              _createElementVNode("p", null, _toDisplayString(_unref(t)('common.fitbike.error.motor.highTemperature.content')), 1)
            ]),
            _: 1
          }, 8, ["title"])
        ]))
      : _createCommentVNode("", true),
    (!_unref(motorStatus).highTemperature && !limitSwitch.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_unref(connected))
            ? (_openBlock(), _createBlock(_unref(BfButton), {
                key: 0,
                type: _unref(ButtonType).Contained,
                onClick: resetMotors
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('common.continue')), 1)
                ]),
                _: 1
              }, 8, ["type"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})